<template>
  <div>
    <h2 class="title mb-4">クリエイティブ設定</h2>
    <div
      ref="mode"
      @changeBudgetSetting="$emit('changeStep', 2)"
      :is="component"
      :form="form"
      :resources="[form.advertiser, form.insertionOrder]"
    />
  </div>
</template>

<script>
import uniq from 'lodash/uniq'
import { CreativeAttachTargets } from '@/models/CampaignOperation'
import CampaignModalPageCreativeModeDeliveryGroup from './CampaignModalPageCreativeModeDeliveryGroup'
import CampaignModalPageCreativeModeCampaign from './CampaignModalPageCreativeModeCampaign'
import CampaignModalPageCreativeModeCampaignWithSchedules from './CampaignModalPageCreativeModeCampaignWithSchedules'
import CreativeScheduleValidation from '@/models/CampaignOperation/Form/CreativeScheduleValidation'
/* eslint vue/no-unused-components: 0 */
export default {
  name: 'CampaignModalPageCreative',
  components: {
    CampaignModalPageCreativeModeDeliveryGroup,
    CampaignModalPageCreativeModeCampaign,
    CampaignModalPageCreativeModeCampaignWithSchedules,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    errorMessage() {
      return uniq(
        this.form
          .getNoRejectedCampaignBudgets()
          .map(cb => CreativeScheduleValidation.getErrorMessages(cb))
          .flat(),
      ).join('<br />')
    },
    attachTarget() {
      return this.form.campaign.creativeAttachTarget
    },
    useCreativeSchedule() {
      return this.form.campaign.useCreativeSchedule
    },
    component() {
      if (this.attachTarget === CreativeAttachTargets.CAMPAIGN) {
        if (this.useCreativeSchedule) {
          return 'CampaignModalPageCreativeModeCampaignWithSchedules'
        } else {
          return 'CampaignModalPageCreativeModeCampaign'
        }
      } else if (this.attachTarget === CreativeAttachTargets.DELIVERY_GROUP) {
        return 'CampaignModalPageCreativeModeDeliveryGroup'
      } else {
        return 'div'
      }
    },
  },
}
</script>
